import { all, fork } from 'redux-saga/effects';
import { dashboardSaga } from './dashboard/dashboard.saga';
import { addEmployeeSaga } from './AddEmployee/AddEmployee.saga';
import { employeelistSaga } from './employeelist/employeelist.saga';
import { loginSagaDetails } from './login/login.saga';
import { dashboardfordepartmentSaga } from './dashboardfordepartment/dashboardfordepartment.saga';
import { sectionWiseFetchDetailsSaga } from './SectionWiseFetchDetails/SectionWiseFetchDetails.saga';
import { branchWiseFetchDetailsSaga } from './BranchWiseFetchDetails/BranchWiseFetchDetails.saga';
import { getValueDashboardForIndividualSaga } from './GetValueDashboardForIndividual/GetValueDasbboardForIndividual.saga';
import { transferEmployeeDetailsSaga } from './TransferEmployee/TransferEmployee.saga';
import { watchReports } from './Reports/Reports.saga';
import { leaveReasonMasterSaga } from './LeaveReasonMaster/LeaveReasonMaster.saga';
import { organisationSagaDetails } from './organisation/organisation.saga';
import { branchSagaDetails } from './branch/branch.saga';
import { sectionSagaDetails } from './section/section.saga';
import { webCheckInSagaDetails } from './webCheckIn/webCheckIn.saga';
import { refreshmentApprovalSaga } from './RefreshmentApproval/RefreshmentApproval.saga';
import { newspaperApprovalSaga } from './NewspaperApproval/NewspaperApproval.saga';
import { visitorPassDetailsSaga } from './visitorPass/visitorPass.sagas';
import { leaveRestrictionSagaDetails } from './leaveRestriction/leaveRestriction.sagas';
import { monthlyCheckoutSaga } from './MonthlyCheckout/MonthlyCheckout.saga';
import { CompOff } from './CompOffReport/CompOffReport.saga';
import { newReportSagaDetails } from './NewReport/NewReport.saga';
import { applyLeaveAdminSaga } from './ApplyLeaveAdmin/ApplyLeaveAdmin.saga';
import { leaveAdjustmentSagaDetails } from './LeaveAdjustment/LeaveAdjustment.saga';
import { resetPasswordSaga } from './ResetPassword/ResetPassword.saga';

export default function* rootSaga() {
	console.log('Root saga started');
	yield all([
		fork(watchReports),
		fork(loginSagaDetails),
		fork(dashboardSaga),
		fork(addEmployeeSaga),
		fork(employeelistSaga),
		fork(dashboardfordepartmentSaga),
		fork(sectionWiseFetchDetailsSaga),
		fork(branchWiseFetchDetailsSaga),
		fork(getValueDashboardForIndividualSaga),
		fork(transferEmployeeDetailsSaga),
		fork(refreshmentApprovalSaga),
		fork(newspaperApprovalSaga),
		fork(leaveReasonMasterSaga),
		fork(organisationSagaDetails),
		fork(branchSagaDetails),
		fork(sectionSagaDetails),
		fork(webCheckInSagaDetails),
		fork(visitorPassDetailsSaga),
		fork(leaveRestrictionSagaDetails),
		fork(monthlyCheckoutSaga),
		fork(CompOff),
		fork(newReportSagaDetails),
		fork(applyLeaveAdminSaga),
		fork(leaveAdjustmentSagaDetails),
		fork(resetPasswordSaga),
	]);
	console.log('Root saga completed');
}
